module.exports = __webpack_public_path__ + "static/news-c55e57b782e1d0e8e05c976d538bc374.jpg";